module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tip":"Tell us what what happened and our support team will try to help you.","send":"Send","successMessage":"Your message has been sent to our support team"}}')
  delete Component.options._Ctor
}
